<template>
  <div :class="$style.container">
    <div :class="$style.content">
      <div :class="$style.column">Наименование</div>
      <div :class="$style.column">ИНН</div>
      <div :class="$style.column">Город</div>
      <div :class="$style.column">Регион</div>
      <div :class="$style.column">Класс</div>
      <div :class="$style.column">Продукт</div>
    </div>
    <div :class="$style.edit">
      <img src="/icons/edit.svg" alt="" />
    </div>
  </div>
</template>

<style lang="scss" module>
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  background-color: $bg-primary;
  padding: 1rem 1.5rem;
  border-top: 1px solid $bg-separator;
  border-bottom: 1px solid $bg-separator;
  @include Subtitle;
  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1 1 auto;
    .column {
      min-width: 9.5rem;
      width: 100%;
      &:last-child {
        min-width: none;
        width: 9.5rem;
      }
    }
  }

  .edit {
    width: 1.5rem;
  }
}
</style>
